import { useNavigate } from 'react-router-dom';
import './style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';

export const ContractCanceled = () => {
  const navigate = useNavigate();

  return (
    <div className="domesticRealEstate-contractCanceled">
      <Description
        label={'出資をお申込みいただいた案件は既に契約解除済みです。'}
        labelColor={labelColor.black}
        labelSize={labelSize.medium}
      />
      <Button
        label={'HOMEに戻る'}
        buttonFill={ButtonFill.link}
        buttonSize={ButtonSize.small}
        onClick={() => navigate(PagePath.Home)}
      />
    </div>
  );
};
